<template>
  <div class="bindCard" v-if="show">
    <div class="backdrop" @click.self="dismiss"></div>
    <div class="dialogContent" ref="dialogContent">
      <span class="close" @click="dismiss"><img src="/static/img/order-close.png" alt=""></span>
      <form class="form-horizontal form-custom" novalidate="novalidate" @submit.prevent="authorization">
        <div class="form-group">
          <label class="control-label">开户行：</label>
          <div class="input-group">
            <input class="form-control" type="text" v-model="repaymentBankBranch" readonly autocomplete="off" placeholder="请输入开户行">
          </div>
        </div>
        <div class="form-group">
          <label class="control-label">账户名：</label>
          <div class="input-group">
            <input class="form-control" type="text" v-model="repaymentCardAccountName" readonly autocomplete="off" placeholder="请输入账户名">
          </div>
        </div>
        <div class="form-group">
          <label class="control-label">账号：</label>
          <div class="input-group">
            <input class="form-control" type="text" v-model="repaymentCardNumber" readonly autocomplete="off" placeholder="请输入账号">
          </div>
        </div>
        <div class="form-group">
          <label class="control-label control-label-phone">银行卡预留手机号：</label>
          <div class="input-group input-group-phone">
            <input class="form-control" type="tel" v-model="repaymentReserveTelNum" readonly autocomplete="off" placeholder="请输入预留手机号">
          </div>
        </div>
        <div class="form-group">
          <label class="control-label">验证码：</label>
          <div class="input-group">
            <input class="form-control form-control-verify" type="tel" v-model="checkCode" autocomplete="off" placeholder="请输入验证码">
            <button class="btn btn-primary btn-verify" :class="{disabled: isSendSms}" @click.prevent="getVerifyCode">{{smsBtnText}}</button>
          </div>
        </div>
        <div class="btn-wrap">
          <p class="err-wrap">
          <span>{{errmsg}}</span>&nbsp;</p>
          <button class="btn btn-primary" type="submit">提&nbsp;&nbsp;交</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      show: false,
      no: '',
      uid: '',
      repaymentBankBranch: '',
      repaymentCardAccountName: '',
      repaymentCardNumber: '',
      repaymentReserveTelNum: '',
      loanStatus: '',
      checkCode: '',
      smsBtnText: '获取验证码',
      errmsg: '',
      isSendSms: false
    }
  },
  props: {
    bindCardSuccess: {
      type: Function,
      required: true
    }
  },
  beforeDestroy () {
    this.timer && clearInterval(this.timer)
  },
  watch: {
    $route () {
      this.show = false
    },
    show () {
      this.checkCode = ''
      this.errmsg = ''
      this.isSendSms = false
      this.isSubmit = false
      this.smsBtnText = `获取验证码`
      this.timer && clearInterval(this.timer)
    }
  },
  methods: {
    dismiss () {
      this.show = false
    },
    getVerifyCode () {
      if (this.isSendSms) {
        return
      }
      this.$http({
        url: '/center/sendVerificationCode.jhtml',
        data: {
          uid: this.uid,
          no: this.no
        },
        done: () => {
          this.isSendSms = true
          let time = 60
          this.smsBtnText = `重新获取(${time})s`
          time--
          this.timer = setInterval(() => {
            if (time < 0) {
              this.isSendSms = false
              this.smsBtnText = `重新获取`
              return clearInterval(this.timer)
            }
            this.smsBtnText = `重新获取(${time})s`
            time--
          }, 1000)
        }
      })
    },
    validate (choice) {
      let rules = {
        // repaymentBankBranch: {
        //   required: '开户行不能为空'
        // },
        // repaymentCardAccountName: {
        //   patterns: [{
        //     pattern: /^(([a-zA-Z+\\.?\\·?a-zA-Z+]{2,30}$)|([\u4e00-\u9fa5+\\·?\u4e00-\u9fa5+]{2,30}$))/,
        //     msg: '请输入中文或英文账户名'
        //   }],
        //   required: '账户名不能为空'
        // },
        // repaymentCardNumber: {
        //   patterns: [{
        //     pattern: /^([1-9]{1})(\d{14}|\d{18})$/,
        //     msg: '账号不正确'
        //   }],
        //   required: '账号不能为空'
        // },
        // repaymentReserveTelNum: {
        //   patterns: [{
        //     pattern: this.$validate.patterns.phone,
        //     msg: '手机格式不正确'
        //   }],
        //   required: '手机号不能为空'
        // },
        checkCode: {
          patterns: [{
            pattern: /^\d{6}$/,
            msg: '短信验证码格式错误'
          }],
          required: '短信验证码不能为空'
        }
      }
      if (choice) {
        let obj = {}
        obj[choice] = rules[choice]
        rules = obj
      }
      let msgField = choice ? choice + 'Msg' : 'errmsg'
      return this.$validate({rules, msgField})
    },
    authorization () {
      if (this.isSubmit) {
        return
      }
      if (this.validate()) {
        this.isSubmit = true
        this.$http({
          url: '/center/doBankCardAuthorization.jhtml',
          data: {
            uid: this.uid,
            no: this.no,
            checkCode: this.checkCode
          },
          done: (info) => {
            this.$dialog({
              content: '已提交',
              onHide: () => {
                this.bindCardSuccess()
                this.show = false
              }
            })
          },
          always: () => {
            this.isSubmit = false
          }
        })
      }
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '../../stylus/mixin'
@import '../../stylus/base'
@import '../../stylus/form'
.bindCard
  position fixed
  top 0
  left 0
  width 100%
  height 100%
  z-index 1000
  .backdrop
    width 100%
    height 100%
    position absolute
    top 0
    left 0
    background-color rgba(0, 0, 0, 0.5)
  .dialogContent
    position absolute
    left 50%
    top 50%
    transform translate(-50%, -50%)
    -ms-transform translate(-50%, -50%)
    width 460px
    background-color #fff
    padding 30px 0 0
    border-radius 2px
    .close
      opacity 0.5
      position absolute
      right 15px
      top 15px
      z-index 10
      &:hover
        opacity 1
      img
        display block
.form-custom
  formgroupW = 460px
  controllabelW = 140px
  phonelableW = 250px
  width formgroupW
  box-shadow none
  border-radius 2px
  .form-group
    height 60px
    border-bottom 1px solid #eff2f1
    margin-bottom 0
    padding 2px 0
    margin-left 0
    margin-right 0
    .control-label
      width controllabelW
      height 56px
      line-height 56px
      padding 0 0 0 40px
      text-align left
      letter-spacing 6px
      margin 0
      float left
      &.control-label-phone
        width phonelableW
    .input-group
      width formgroupW - controllabelW
      float left
      &.input-group-phone
        width formgroupW - phonelableW
    .form-control
      width 100%
      height 56px
      border none
      &.form-control-verify
        width 150px
    .btn-verify
      width 150px
      height 45px
      margin-top 5px
      letter-spacing 3px
  .btn-wrap
    text-align center
    border-top 1px solid #eff2f1
    height 70px !important
    .btn
      width 150px
      height 50px
      background-color #2a9ffa
      border none
    .btn-primary
      position absolute
      width 150px
      height 50px
      line-height 50px
      padding 0
      font-size 16px
      left 50%
      bottom 0
      transform translate(-50%, 50%)
      -ms-transform translate(-50%, 50%)
  .err-wrap
    padding 0 40px
    text-align left
    margin 10px 0
    color #a94442
</style>



// WEBPACK FOOTER //
// bind-card.vue?fb687bee